import { render, staticRenderFns } from "./PartnersListPage.vue?vue&type=template&id=60ea3c22&"
import script from "./PartnersListPage.vue?vue&type=script&lang=js&"
export * from "./PartnersListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports